/** Match a legal company the same way the backend resolveLegalCompany helper does. */
export function matchLegalCompany(
  companies,
  { companyId, countryCode, currency, fallbackDefault = true } = {}
) {
  const list = companies || [];
  if (companyId) {
    const hit = list.find((c) => String(c.id) === String(companyId));
    if (hit) return hit;
  }
  const country = String(countryCode || '').trim().toUpperCase();
  const curr = String(currency || '').trim().toUpperCase();
  if (country && curr) {
    const both = list.find(
      (c) =>
        String(c.country_code || '').toUpperCase() === country &&
        String(c.base_currency || '').toUpperCase() === curr
    );
    if (both) return both;
  }
  if (curr) {
    const byCurrency = list.filter((c) => String(c.base_currency || '').toUpperCase() === curr);
    if (byCurrency.length === 1) return byCurrency[0];
    if (country) {
      const withCountry = byCurrency.find(
        (c) => String(c.country_code || '').toUpperCase() === country
      );
      if (withCountry) return withCountry;
    }
  }
  if (country) {
    const byCountry = list.filter((c) => String(c.country_code || '').toUpperCase() === country);
    if (byCountry.length === 1) return byCountry[0];
  }
  if (!fallbackDefault) return null;
  return list.find((c) => c.is_default) || list[0] || null;
}

/** Stamp a buying document from explicit company, then vendor company, then country/currency. */
export function resolveDocumentCompanyId(
  companies,
  { companyId, vendor, countryCode, currency } = {}
) {
  const matched = matchLegalCompany(companies, {
    companyId: companyId || vendor?.company_id || null,
    countryCode: countryCode || vendor?.country_code,
    currency: currency || vendor?.currency,
    fallbackDefault: false,
  });
  return matched?.id || companyId || vendor?.company_id || '';
}

export function companyOptionLabel(company) {
  if (!company) return '';
  const bits = [company.legal_name || 'Company'];
  if (company.country_code) bits.push(company.country_code);
  if (company.base_currency) bits.push(company.base_currency);
  if (company.is_default) bits.push('default');
  return bits.join(' · ');
}
